import type React from 'react';
import { translate, translateFormatter, type RichTextFormatter } from '@/domains/core/localization/translate';
export const {
  genericCouponFooter,
  couponCode,
  offerText,
  bulkPurchaseCouponLabel,
  bulkPurchaseBySellerCouponLabel,
  bulkPurchaseBySellerCouponDescription,
  bulkPurchaseBySellerCouponTooltipTitle,
  codeLabelPrefix,
  copyAction
} = translate({
  "genericCouponFooter": "Terms & Conditions",
  "couponCode": "To be applied on the payment page",
  "offerText": "Offered",
  "bulkPurchaseCouponLabel": "Quantity discount with code",
  "bulkPurchaseBySellerCouponLabel": "Select coupon at payment",
  "bulkPurchaseBySellerCouponDescription": "Non-cumulative with other discount codes. Coupon inc. VAT.",
  "bulkPurchaseBySellerCouponTooltipTitle": "Find your coupon at payment",
  "codeLabelPrefix": "CODE :",
  "copyAction": "Code copied"
});
export const bulkPurchaseCouponDescription = translateFormatter<{
  amount: string | number;
  span: RichTextFormatter;
}>([{
  "type": 0,
  "value": "Discount on price inc VAT. Coupon value: "
}, {
  "type": 8,
  "value": "span",
  "children": [{
    "type": 1,
    "value": "amount"
  }]
}], undefined, undefined, "en");
export const bulkPurchaseBySellerCouponTooltipContent = translateFormatter<{
  p: React.ElementType;
  image: React.ElementType;
}>([{
  "type": 8,
  "value": "p",
  "children": [{
    "type": 0,
    "value": "Apply this coupon to your order in the 'discount code' box on the payment page, just after the delivery page."
  }]
}, {
  "type": 8,
  "value": "image",
  "children": []
}], undefined, undefined, "en");
export const linkToConditions = translateFormatter<{
  strong: RichTextFormatter;
}>([{
  "type": 8,
  "value": "strong",
  "children": [{
    "type": 0,
    "value": "Offer valid"
  }]
}, {
  "type": 0,
  "value": " today only."
}], undefined, undefined, "en");